export default __webpack_public_path__ + "static/media/1977.1541f4cc.png";